import React from "react";
import CheckboxInput from "../../FormInputs/Checkbox";

const NewCheckbox = (props)=>{

    const changeHandler=(val,event)=>{
        props.changeHandler(val,event);
    }
    return(
        <td scope="col" className="initaltd">
            <div >
                <div className="form-check-inline" style={{display:'inline-block'}}>
                    <CheckboxInput 
                    changeHandler={changeHandler}
                    id={props.rowId}
                    value={props.value}
                    />
                </div>
            </div>
        </td>
    )
}
NewCheckbox.defaultProps ={
    changeHandler:()=>{},
    isSortable:false
}
export default NewCheckbox;